import React from "react";
import Header from "../components/portfolio/Header";
import Hero from "../components/portfolio/Hero";
import About from "../components/portfolio/About";
import Timeline from "../components/portfolio/Timeline";
import Books from "../components/portfolio/Books";
import Awards from "../components/portfolio/Awards";
import Honors from "../components/portfolio/Honors";
import Sports from "../components/portfolio/Sports";
import Philanthropy from "../components/portfolio/Philanthropy";
import Media from "../components/portfolio/Media";
import Gallery from "../components/portfolio/Gallery";
import Blog from "../components/portfolio/Blog";
import Events from "../components/portfolio/Events";
import Contact from "../components/portfolio/Contact";
import Footer from "../components/portfolio/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-paper">
      <Header />
      <main>
        <Hero />
        <About />
        <Timeline />
        <Books />
        <Awards />
        <Honors />
        <Sports />
        <Philanthropy />
        <Media />
        <Gallery />
        <Blog />
        <Events />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
